import { createSlice } from "@reduxjs/toolkit";

export const quoteApprovalDetailsSlice = createSlice({
  name: "quoteApprovalDetailsSlice",
  initialState: {
    quoteApprovalDetails: null,
  },
  reducers: {
    setQuoteApprovalDetails: (currentSlice, action) => {
      currentSlice.quoteApprovalDetails = action.payload;
    },
    clearQuoteApprovalDetails: (currentSlice) => {
      currentSlice.quoteApprovalDetails = null;
    },
  },
});

export const { setQuoteApprovalDetails, clearQuoteApprovalDetails } =
  quoteApprovalDetailsSlice.actions;
export const quoteApprovalDetailsReducer = quoteApprovalDetailsSlice.reducer;
